import { defineStore } from 'pinia';

export const useGeneralModalStore = defineStore('general-modal-store', () => {
  const allModals = reactive<Record<string, boolean>>({
    showCreateBillItemsDialog: false,
    showRecordManualPaymentDialog: false,
  });

  const toggleModalByName = (modalName: string) => {
    allModals[modalName] = !allModals[modalName];
  };

  return {
    allModals,
    toggleModalByName,
  };
});
